<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2025-11-22 12:07 -->
<!-- Description: Simple pagination component using Bootstrap 4.6 -->
<template>
  <nav aria-label="Page navigation" v-if="pagination.total > 0">
    <ul class="pagination justify-content-center mb-2">
      <!-- Previous Button -->
      <li class="page-item" :class="{ disabled: pagination.current_page <= 1 }">
        <a 
          class="page-link" 
          href="#" 
          @click.prevent="changePage(pagination.current_page - 1)" 
          aria-label="Previous"
        >
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>

      <!-- Page Numbers -->
      <li
        v-for="page in pages"
        :key="page"
        class="page-item"
        :class="{ active: page === pagination.current_page }"
      >
        <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
      </li>

      <!-- Next Button -->
      <li class="page-item" :class="{ disabled: pagination.current_page >= lastPage }">
        <a 
          class="page-link" 
          href="#" 
          @click.prevent="changePage(pagination.current_page + 1)" 
          aria-label="Next"
        >
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>
    </ul>
    <div class="text-center text-muted small">
        Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries
    </div>
  </nav>
</template>

<script>
export default {
  name: "paginate-simple",
  props: {
    pagination: {
      type: Object,
      required: true,
      // Expected structure: { current_page, total, per_page, from, to }
    },
    offset: {
      type: Number,
      default: 4
    }
  },

  computed: {
    lastPage() {
      if (this.pagination.last_page) {
        return this.pagination.last_page;
      }
      return Math.ceil(this.pagination.total / this.pagination.per_page);
    },
    pages() {
      if (!this.pagination.total) {
        return [];
      }
      
      let from = this.pagination.current_page - this.offset;
      if (from < 1) {
        from = 1;
      }
      
      let to = from + (this.offset * 2);
      if (to >= this.lastPage) {
        to = this.lastPage;
      }
      
      // Adjust 'from' if 'to' hit the ceiling and we have enough pages to show full range
      // But for simplicity, just ensuring 'from' is valid is enough.
      // If we want to keep the window size constant when near the end:
      /*
      const windowSize = this.offset * 2 + 1;
      if (to - from + 1 < windowSize && from > 1) {
          from = to - windowSize + 1;
          if (from < 1) from = 1;
      }
      */

      let pagesArray = [];
      for (let page = from; page <= to; page++) {
        pagesArray.push(page);
      }
      return pagesArray;
    }
  },

  methods: {
    changePage(page) {
      if (page < 1 || page > this.lastPage || page === this.pagination.current_page) {
        return;
      }
      this.$emit("change", page);
    }
  }
};
</script>

<style scoped>
.page-link {
    cursor: pointer;
}
</style>
